
import { GroupItemMapingFromDb, Groups } from "../model/Groups";
import { UserData, UserItemMapingFromDb } from "../model/Users";
import { removeNullFields, toCamelCase } from "../utility/ConvertUtily";
import axiosCilent from "./axiosClient";

// グループ取得
export const requestGetGroups = async (
  tenantId: string,
  pageNo: number,
  limit: number,
  sortField: string,
  sortOrder: string
): Promise<{
  success: true;
  groups: Groups[];
  totalCount: number;
  activeCount: number;
  totalPages: number;
} | { success: false; error: any }> => {
  try {
    const requestBody = {
      tenantId,
      page: pageNo,
      limit,
      sortField,
      sortOrder,
    };
    const response = await axiosCilent.post("/getGroupListDb", requestBody, { timeout: 0 });
    const groups = toCamelCase(removeNullFields(response.data.groups));
    const groupDataList: Groups[] = groups.map((group: any) => ({
      ...GroupItemMapingFromDb(group)
    }));

    return {
      success: true,
      groups: groupDataList,
      totalCount: response.data.totalCount,
      activeCount: response.data.activeCount,
      totalPages: response.data.totalPages,
    };
  } catch (error) {
    return { success: false, error };
  }
};

// グループ管理者取得
export const requestGetGroupAdmin = async (
  tenantId: string,
  groupId: string,
): Promise<{
  success: true;
  users: UserData[];
} | { success: false; error: any }> => {
  try {
    const requestBody = {
      tenantId,
      groupId,
    };

    // DBからグループ管理者一覧を取得するエンドポイントをコール
    const response = await axiosCilent.post("/getGroupAdminListDb", requestBody, { timeout: 0 });

    const users = toCamelCase(removeNullFields(response.data.users));
    const userDataList: UserData[] = users.map((user: any) => ({
      ...UserItemMapingFromDb(user),
      salt: null,
      encryptedPasscode: null,
      decryptedPasscode: null,
      password: null,
      passcode: null,
      iv: null,
      possessedPointMap: [],
      expirationPointMap: [],
    }));

    return {
      success: true,
      users: userDataList,
    };
  } catch (error) {
    return { success: false, error };
  }
};